import { NgModule } from '@angular/core';

import { RtUIAttributesModule } from './attributes/attributes.module';
import { RtUIColorPickerModule } from './color-picker/color-picker.module';
import { RtUICommonModule } from './common/common.module';
import { RtUICoreModule } from './core/core.module';
import { RtUIDataTableModule } from './data-table/data-table.module';
import { RtUIDialogModule } from './dialog/dialog.module';
import { RtUIDialogsModule } from './dialogs/dialogs.module';
import { RtUIFormsModule } from './forms/forms.module';
import { RtUIListsModule } from './lists/lists.module';
import { RtUINotificationsModule } from './notifications/notifications.module';
import { RtUITourHighlightModule } from './tour-highlight/tour-highlight.module';

const RT_UI_MODULES = [
  RtUIAttributesModule,
  RtUICoreModule,
  RtUICommonModule,
  RtUIColorPickerModule,
  RtUIDataTableModule,
  RtUIDialogModule,
  RtUIDialogsModule,
  RtUIFormsModule,
  RtUIListsModule,
  RtUINotificationsModule,
  RtUITourHighlightModule,
];

@NgModule({
  imports: [...RT_UI_MODULES],
  exports: [RT_UI_MODULES],
})
export class RtUIModule {}
